<script context='module' lang='ts'>
  import type { Storefront } from 'app/javascript/shared/javascripts/types/Storefront';

  export const selectAlternatives = function(storefront:Storefront, orientation:string) {
    return storefront.storefront_featured_products_attributes.filter(function(fp) {
      return fp.orientation == orientation
    });
  };

  export const orderAlternativesByPreview = function(storefront:Storefront, orientation: string) {
    return selectAlternatives(storefront, orientation).sort((a, b) => {
      return a.preview_alternative_index - b.preview_alternative_index
    })
  }

  export const countAlternatives = function(storefront:Storefront, orientation:string) {
    return selectAlternatives(storefront, orientation).length
  };

  export const waitForElementToDisplay = function(selector, checkFrequencyInMs, timeoutInMs, cb) {
    var startTimeInMs = Date.now();
    (function loopSearch() {
      let el = document.querySelector(selector)
      if (el != null) {
        cb(el);
        return;
      }
      else {
        setTimeout(function () {
          if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
            return;
          loopSearch();
        }, checkFrequencyInMs);
      }
    })();
  }
</script>